// banner管理
import http from "@/jslibs/axios/http";

// banner列表
export const list = (data) => http.get("/v1/cms/banner", data);

// banner新增
export const add = (data) => http.post("/v1/cms/banner", data);

// banner编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/banner/${uuid}`, data);

// banner删除
export const del = ({ uuid }) => http.delete(`/v1/cms/banner/${uuid}`);

// banner详情
export const detail = ({ uuid }) => http.get(`/v1/cms/banner/${uuid}`);
